import * as React from "react";
import { IconSwords, IconShield, IconTrophy, IconX, IconChevronsRight } from "@tabler/icons-react";
import "./battle-field.css";

const TROOPS = ["Стражи", "Штурмовики", "Алхимики"];
const sum = values => values.reduce((total, n) => total + n, 0);

export function BattleField({ result, onClose }) {
  const dialog = React.useRef(null);
  const battle = result.battle;
  const events = battle.events;
  const [step, setStep] = React.useState(0);
  const reduced = React.useRef(false);
  const complete = step >= events.length;
  const forest = result.action === "expedition";
  React.useEffect(() => {
    const element = dialog.current;
    const previous = document.activeElement;
    element.showModal();
    reduced.current = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced.current) setStep(events.length);
    return () => { element.close(); previous?.focus?.(); };
  }, [events]);
  React.useEffect(() => {
    if (complete || reduced.current) return;
    const timer = setTimeout(() => setStep(n => n + 1), Math.max(100, Math.min(450, 12000 / events.length)));
    return () => clearTimeout(timer);
  }, [step, complete, events]);
  const visible = events.slice(0, step);
  const last = visible.at(-1);
  const counts = complete ? battle.survivors : [...visible].reverse().find(e => e.counts)?.counts || battle.initial;
  const round = last?.round || 1;
  const title = /тумана ослаблена/i.test(result.text) ? "Туман отступает" : result.won ? "Победа!" : "Отряд отступил";
  const opponent = result.opponent || (forest ? "Лесной тайник" : "Защитники");
  return <dialog ref={dialog} className="kh-battle-dialog" aria-label={forest ? "Лесная вылазка" : "Сражение"} onCancel={onClose}>
    <div className="kh-battle-screen">
      <header className="kh-battle-screen__header">
        <div><small>ЦАРЬ ГОРЫ · {forest ? "ЛЕСНАЯ ВЫЛАЗКА" : "СРАЖЕНИЕ"}</small><h2>{complete ? title : forest ? "Схватка в лесу" : "Бой за колонию"}</h2></div>
        <button type="button" className="kh-battle-screen__close" aria-label="Закрыть бой" onClick={onClose}><IconX size={20} /></button>
      </header>
      <div className="kh-battle-screen__scroll">
        <div className="kh-battle-contenders"><div><IconSwords size={17} /><span>Ваш отряд</span><b>{sum(counts[0])} бойцов</b></div><span>VS</span><div><IconShield size={17} /><span>{opponent}</span><b>{sum(counts[1])} бойцов</b></div></div>
        <section className={`kh-battle-arena ${forest ? "is-forest" : "is-nest"} ${complete ? "is-complete" : ""}`} aria-label="Поле сражения">
          <div className="kh-battle-arena__top"><span>{complete ? "Сражение завершено" : `Раунд ${round}`}</span>{!complete && <button type="button" onClick={() => setStep(events.length)}><IconChevronsRight size={16} />Пропустить</button>}</div>
          <div className="kh-battle-armies">{counts.map((army, side) => <div className={`kh-battle-army kh-battle-army--${side}`} key={side}>{army.map((number, troop) => {
            const striking = !complete && last?.side === side && last?.troop === troop;
            const hit = !complete && last?.side === 1-side && last?.target === troop;
            return <div className={`kh-battle-unit ${number === 0 ? "is-out" : ""} ${striking ? "is-striking" : ""} ${hit ? "is-hit" : ""}`} key={`${troop}:${striking}:${hit}`}>
              <div className="kh-battle-unit__art"><img src={`/assets/king-hill/troop-${troop}.webp`} alt={TROOPS[troop]} />{hit && <em>−{last.damage}</em>}</div>
              <span>{TROOPS[troop]}</span><b>×{number} <small>ур. {battle.levels[side][troop]}</small></b>
            </div>;
          })}</div>)}</div>
          {complete && <div className={`kh-battle-banner ${result.won ? "is-win" : ""}`}><IconTrophy size={22} /><strong>{title}</strong></div>}
        </section>
        <p className="kh-battle-comment" role="status">{complete ? "Результат сохранён" : last?.damage ? `${TROOPS[last.troop]} ${last.side === 0 ? "вашего отряда" : "защитников"} наносят ${last.damage} урона` : "Отряды занимают позиции"}</p>
        {complete && <section className="kh-battle-report"><h3>Отчёт боя</h3><p>{result.text}</p><div className="kh-battle-report__numbers">{[0,1].map(side => <div key={side}><b>{side === 0 ? "Ваш отряд" : "Защитники"}</b><span>В строю <strong>{sum(battle.survivors[side])}</strong></span><span>{forest && side === 1 ? "Выбыли" : "Ранены"} <strong>{sum(battle.initial[side])-sum(battle.survivors[side])}</strong></span></div>)}</div>{result.defender_shield_until && <p className="kh-battle-report__shield"><IconShield size={16} />Гнездо защитника получило щит от повторных атак.</p>}</section>}
      </div>
      <footer className="kh-battle-screen__footer"><button type="button" autoFocus onClick={() => complete ? onClose() : setStep(events.length)}>{complete ? "Вернуться к колонии" : "К результату боя"}</button></footer>
    </div>
  </dialog>;
}
